import React, { createElement } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { CrownControlPage } from './pages/CrownControlPage';
import { CartProvider } from './contexts/CartContext';
import { CartPopup } from './components/CartPopup';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <script type="text/javascript" data-id="element-2">
          {`(function(c,l,a,r,i,t,y){
c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "vm6gh8mfkk");`}
        </script>
      </Helmet>
      <CartProvider data-id="element-3">
        <CrownControlPage data-id="element-4" />
        <CartPopup data-id="element-5" />
      </CartProvider>
    </HelmetProvider>;
}